import { OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult, CSSResultArray } from 'lit';
import { customElement } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { AdoptedStyleSheets } from '@phase2/outline-adopted-stylesheets-controller';

import componentStyles from './pc-footer.css.lit';
import globalStyles from './pc-footer.lightDom.css.lit';

import '../pc-icon/pc-icon';
import '../pc-container/pc-container';

/**
 * Footer component
 * @element pc-footer
 */
@customElement('pc-footer')
export class PCFooter extends OutlineElement {
  adoptedStylesheets: AdoptedStyleSheets;
  static styles: CSSResultArray = [componentStyles];

  connectedCallback() {
    super.connectedCallback();
    this.adoptedStylesheets = new AdoptedStyleSheets(globalStyles);
    this.addController(this.adoptedStylesheets);
  }

  render(): TemplateResult {
    const buttonClasses = {
      footer: true,
    };

    return html`
      <footer class=${classMap(buttonClasses)}>
        <div class="primary">
          <div class="section">
            <pc-container>
              <slot name="primary"></slot>
            </pc-container>
          </div>
        </div>

        <div class="ancillary">
          <div class="section">
            <pc-container>
              <slot name="ancillary"></slot>
            </pc-container>
          </div>
        </div>
      </footer>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-footer': PCFooter;
  }
}
